import { useAuth } from "@/App";
import { Link } from "react-router-dom";
import { Lock, Sparkles, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Paywall({ children }) {
  const { subscription } = useAuth();

  if (!subscription || subscription.has_access) {
    return children;
  }

  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="paywall">
      <div className="bg-[#18181b] border border-white/5 rounded-sm p-8">
        <div className="w-14 h-14 rounded-sm bg-[#DFFF00]/10 flex items-center justify-center mx-auto mb-6">
          <Lock className="h-7 w-7 text-[#DFFF00]" />
        </div>

        <h2 style={{ fontFamily: 'Oswald, sans-serif' }} className="font-bold text-2xl uppercase tracking-tight text-white mb-2">
          Din prøveperiode er udløbet
        </h2>
        <p className="text-sm text-zinc-400 mb-6">
          Opgrader til FitrackR Pro for at fortsætte med at bruge alle funktioner.
        </p>

        <div className="bg-zinc-900/50 rounded-sm p-4 mb-6 border border-white/5">
          <div className="flex items-center justify-center gap-1 mb-1">
            <span style={{ fontFamily: 'JetBrains Mono, monospace' }} className="text-3xl font-bold text-[#DFFF00]">49</span>
            <span className="text-sm text-zinc-400">kr/md</span>
          </div>
          <p className="text-xs text-zinc-500">Fuld adgang til alle funktioner</p>
        </div>

        <div className="space-y-2 text-left mb-6">
          {["AI-genererede træningsprogrammer", "AI-genererede madplaner", "Træningstracker & historik", "Øvelsesbibliotek med 85+ øvelser", "Inspiration & ekspertviden"].map(f => (
            <div key={f} className="flex items-center gap-2 text-sm text-zinc-300">
              <Sparkles className="h-3.5 w-3.5 text-[#DFFF00] flex-shrink-0" />
              <span>{f}</span>
            </div>
          ))}
        </div>

        <Link to="/upgrade" data-testid="paywall-upgrade-btn">
          <Button className="w-full bg-[#DFFF00] text-black hover:bg-[#C8E600] rounded-sm font-bold uppercase tracking-wider h-12">
            Opgrader nu — 49 kr/md
          </Button>
        </Link>
      </div>
    </div>
  );
}
